import { Link } from "react-router-dom";
import { Mail, MapPin, Linkedin, ArrowUpRight } from "lucide-react";

function FooterBrand() {
  return (
    <div className="md:col-span-5">
      <Link to="/" aria-label="X-HRverse home" className="inline-block">
        <img
          src="https://customer-assets.emergentagent.com/job_recruit-hub-201/artifacts/m39dxinf_Dynamic_Tech_Company_Logo_-_X-HRverse-removebg-preview.png"
          alt="X-HRverse"
          className="h-20 w-auto object-contain"
        />
      </Link>
      <p className="mt-5 max-w-md text-white/65 leading-relaxed">
        Strategic workforce solutions: direct placement, RPO, and HR services for
        modern businesses across the United States.
      </p>
      <div className="mt-6 flex flex-col gap-2 text-sm text-white/70">
        <a href="mailto:robert@x-hrverse.com" className="inline-flex items-center gap-2 hover:text-white">
          <Mail className="h-4 w-4" /> robert@x-hrverse.com
        </a>
        <span className="inline-flex items-center gap-2">
          <MapPin className="h-4 w-4" /> United States · Remote-first
        </span>
      </div>
    </div>
  );
}

function FooterLinks() {
  return (
    <>
      <div className="md:col-span-2">
        <p className="overline text-white/50 mb-4">Company</p>
        <ul className="space-y-2 text-sm">
          <li><Link to="/about" className="text-white/80 hover:text-white">About</Link></li>
          <li><Link to="/services" className="text-white/80 hover:text-white">Services</Link></li>
          <li><Link to="/industries" className="text-white/80 hover:text-white">Industries</Link></li>
          <li><Link to="/blog" className="text-white/80 hover:text-white">Blog</Link></li>
          <li><Link to="/contact" className="text-white/80 hover:text-white">Contact</Link></li>
        </ul>
      </div>
      <div className="md:col-span-2">
        <p className="overline text-white/50 mb-4">Services</p>
        <ul className="space-y-2 text-sm text-white/80">
          <li>Direct Placement</li>
          <li>RPO Solutions</li>
          <li>HR Services</li>
          <li>Executive Search</li>
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="overline text-white/50 mb-4">Get in touch</p>
        <p className="text-sm text-white/70 mb-4">
          Ready to build a stronger team? Tell us about your hiring goals.
        </p>
        <Link
          to="/contact"
          data-testid="footer-cta"
          className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-md text-sm font-medium bg-[#E45E3B] text-white hover:bg-[#c84d2e] transition-colors"
        >
          Request Recruiting Support
          <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </>
  );
}

function FooterBottom() {
  return (
    <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
      <p>© {new Date().getFullYear()} X-HRverse. All rights reserved.</p>
      <div className="flex items-center gap-5">
        <a href="https://www.linkedin.com/company/x-hrverse/" target="_blank" rel="noopener noreferrer" className="hover:text-white inline-flex items-center gap-1.5"><Linkedin className="h-3.5 w-3.5"/> LinkedIn</a>
        <a href="#" className="hover:text-white">Privacy</a>
        <a href="#" className="hover:text-white">Terms</a>
      </div>
    </div>
  );
}

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#070908] text-[#F4F4F1] mt-24 border-t border-border">
      <div className="container-x py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <FooterBrand />
          <FooterLinks />
        </div>
        <FooterBottom />
      </div>
    </footer>
  );
}
